"use strict";

require("core-js/modules/es6.object.define-property");

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var verbosityLevels = {
  debug: 1,
  info: 2,
  log: 3,
  warn: 4,
  error: 5
};
var logLevel = verbosityLevels.log;

var printWithVerbosity = function printWithVerbosity(verbosity) {
  var values = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }

  if (logLevel <= verbosity && process.env.NODE_ENV === "development") {
    // tslint:disable-next-line:no-console
    console.log.apply(console, values);
  }
};

var createPrinter = function createPrinter(verbosity) {
  return function () {
    var values = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      values[_i] = arguments[_i];
    }

    return printWithVerbosity.apply(void 0, __spreadArrays([verbosity], values));
  };
};

exports["default"] = {
  debug: createPrinter(verbosityLevels.debug),
  info: createPrinter(verbosityLevels.info),
  log: createPrinter(verbosityLevels.log),
  warn: createPrinter(verbosityLevels.warn),
  error: createPrinter(verbosityLevels.error)
};